module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Portfolio hinzufügen","portfolioOptionsLabel":"Portfolio","loading":"Laden…","submitButtonLabel":"Speichern","roleLabel":"Berechtigung","userNotFound":"Benutzer nicht gefunden","roleLabels":{"USER":"USER","MANAGER":"MANAGER"}}}')
  delete Component.options._Ctor
}
